import { render, staticRenderFns } from "./BcbCustomerDetail.vue?vue&type=template&id=1b49bbfe&scoped=true"
import script from "./BcbCustomerDetail.vue?vue&type=script&lang=js"
export * from "./BcbCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./BcbCustomerDetail.vue?vue&type=style&index=0&id=1b49bbfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49bbfe",
  null
  
)

export default component.exports